module.exports = __webpack_public_path__ + "img/megalabs.a0391899.jpg";